import React, { useMemo } from 'react';
import { teammateLabels } from '../../lib/teammateLabels';

/**
 * Contacts toolbar: "Referred by" (#793 S6). Narrows the list to leads a partner
 * app credited to a teammate (`attribution.referred_by_user_id`), via the
 * `referred_by` query parameter of `GET /api/contacts` — `me` or a user id.
 *
 * #799 QA: the signed-in user is "me", not also listed by name; a name two
 * teammates share is shown with each one's email.
 */
export default function ReferredByFilter({ value, onChange, teamMembers, currentUserId }) {
    const labels = useMemo(() => teammateLabels(teamMembers), [teamMembers]);
    const others = (teamMembers || []).filter((m) => m.user_id !== currentUserId);
    const selected = value === currentUserId && currentUserId ? 'me' : value;
    return (
        <select
            value={selected}
            onChange={(e) => onChange(e.target.value)}
            data-testid="contacts-referred-by-filter"
            aria-label="Referred by"
            className="px-2.5 py-1.5 text-sm border border-stone-200 rounded-lg bg-white focus:outline-none"
            title="Filter contacts by the teammate a partner app credited"
        >
            <option value="">Referred by anyone</option>
            <option value="me">Referred by me</option>
            {/* A deep link can name someone not (or not yet) in the team list; show
                that the list is filtered rather than "anyone". */}
            {selected && selected !== 'me' && !others.some((m) => m.user_id === selected) && (
                <option value={selected}>Referred by another user</option>
            )}
            {others.map((m) => (
                <option key={m.user_id} value={m.user_id}>Referred by {labels.get(m.user_id)}</option>
            ))}
        </select>
    );
}

/** The initial filter from the URL (`/contacts?referred_by=me`, Profile's "View in Contacts"). */
export function referredByFromSearch(search) {
    try {
        return new URLSearchParams(search || '').get('referred_by') || '';
    } catch {
        return '';
    }
}
